import { createAction, createSlice } from '@reduxjs/toolkit';

export interface Goal {
  goalId: string;
  title: string;
  description: string;
  startDate: string;
  endDate: string;
  status: string;
}

type GoalState = {
  goals: Goal[];
  count: number;
};

const initialState: GoalState = {
  goals: [],
  count: 0,
};

const goalsReducer = createSlice({
  name: 'goals',
  initialState,
  reducers: {
    setGoals: (state, action) => {
      state.goals = action.payload.goals;
      state.count = action.payload.count;
    },
    createGoal: (state, action) => {
      state.goals = [action.payload, ...state.goals];
      state.count += 1;
    },
    updateGoal: (state, action) => {
      const index = state.goals.findIndex((goal) => goal.goalId === action.payload.goalId);
      if (index !== -1) {
        state.goals[index] = action.payload;
      }
    },
  },
});

export const { setGoals, createGoal, updateGoal } = goalsReducer.actions;
export default goalsReducer;